import { ComponentType } from "react";
import { SetupPermission } from "../types";
import { Tenant } from "../types-generated";
export type SetupComponentProps = {
  tenants: Tenant[];
};
export class SetupService {
  private static instance: SetupService;
  private setupComponents: Record<string, ComponentType<SetupComponentProps>> =
    {};
  private permissions: SetupPermission[] = [];
  private constructor() {}

  public static getInstance(): SetupService {
    if (!SetupService.instance) {
      SetupService.instance = new SetupService();
    }
    return SetupService.instance;
  }

  public addDefaultPermission(perm: SetupPermission, allowDuplicates = false) {
    if (!this.permissions.find((p) => p.key === perm.key) || allowDuplicates) {
      this.permissions.push(perm);
    }
  }
  public getDefaultPermissions() {
    return this.permissions;
  }
  public getSetupComponents() {
    return this.setupComponents;
  }
  public registerSetupComponent(
    key: string,
    component: ComponentType<SetupComponentProps>
  ) {
    this.setupComponents[key] = component;
  }

  public getSetupComponent(key: string) {
    return this.setupComponents[key];
  }
}
